import { render } from "./ClientCMSProductRevision.vue?vue&type=template&id=7248024a&scoped=true"
import script from "./ClientCMSProductRevision.vue?vue&type=script&lang=js"
export * from "./ClientCMSProductRevision.vue?vue&type=script&lang=js"

import "./ClientCMSProductRevision.vue?vue&type=style&index=0&id=7248024a&lang=css"
import "./ClientCMSProductRevision.vue?vue&type=style&index=1&id=7248024a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7248024a"]])

export default __exports__